<template>
  <!-- 運送一覧 -->
  <div v-loading="showFlag">
    <t-card class="card_common">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_製品備考などの追加、製品選択が不要になる -->
            <!-- 新規 -->
            <!-- <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button> -->
            &nbsp;
            <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ --> </t-col
          ><t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_EIGHT'))"
            class="col_common_center"
          >
            <!-- 削除 -->
            <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
            <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要　　　 -->
            <!-- <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
            > -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
              :disabled="!isDLUserLocal"
            >
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button></t-col
          >
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form :model="searchConditionForm" label-width="80px">
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="13">
                  <div>
                    <t-form-item class="dateLabelWidth" label-width="180px">
                      <span slot="label">
                        <div style="margin-top: 1px">
                          <t-radio-group
                            v-model="transDateLabel"
                            size="small"
                            style="margin-right: 5px"
                          >
                            <t-radio-button label="1">{{
                              $t("resource.TRANSPORT.DEPARTURE_DATE")
                            }}</t-radio-button>
                            <t-radio-button label="2">{{
                              $t("resource.TRANSPORT.EXPECT_DATE_ARRIVE")
                            }}</t-radio-button>
                          </t-radio-group>
                        </div>
                      </span>

                      <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        style="min-width: 20px; width: 75%; margin-top: -12px"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        :editable="false"
                        class="date_icon_center"
                        :clearable="false"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>

                <t-col :span="5">
                  <!-- 状態 -->
                  <t-form-item :label="$t('resource.TRANSPORT.STATUS')">
                    <t-select
                      v-model="searchConditionForm.searchStatus"
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                      clearable
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
              </t-row>
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="18" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      clearable
                      maxlength="50"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.search.spaceSpan'))"
                  class="col_block_left"
                  >&nbsp;</t-col
                >
                <t-col
                  :span="
                    parseInt($t('widgetSize.TRANSPORT.SEARCH_BUTTON_SPAN'))
                  "
                >
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search marginRight"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.TRANSPORT.SPACE_SPAN_ONE'))"
                  class="col_block_left"
                  >&nbsp;</t-col
                >
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="transportTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
          fit
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <!-- 状態 -->
          <t-table-column
            prop="tbTransStatus"
            :label="$t('resource.TRANSPORT.STATUS')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.TRANSPORT.STATUS'),
                'tbTransStatus'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="order-status">{{ row.tbTransStatus }} </span>
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="transportTableDataLength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  deleteTransBasicByTransNo,
  initTransSearchList,
  searchTransBasic,
} from "@/services/transport";
//import { DateFormat } from "@/utils/filter";
import { ShowTransportEditDialog } from "@/components/Dialog";
import {
  formatCurDateToString,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import { GetPageDataCount, STR_ONE, STR_ZERO } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      // 検索条件
      dateRange: [],
      searchConditionForm: {
        searchStartDate: "",
        searchEndDate: "",
        searchStatus: "",
        isDepartureDate: "",
        searchWord: "",
      },
      transDateLabel: STR_ONE,
      //ターブルデータ
      transportTableData: [],

      // 運送リスト
      statusList: [],

      userList: [],

      // ターブル列
      columns: [
        // 運送No.
        {
          prop: "tbTransOrderNo",
          label: t("resource.TRANSPORT.TRANSPORT_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 輸送方式
        {
          prop: "tbTransMethod",
          label: t("resource.TRANSPORT.TRANSPORT_METHOD"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 出発日
        {
          prop: "tbDepartureDate",
          label: t("resource.TRANSPORT.DEPARTURE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 到着予定日
        {
          prop: "tbEstArrivalDate",
          label: t("resource.TRANSPORT.EXPECT_DATE_ARRIVE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 連絡担当
        {
          prop: "tbUserCode",
          label: t("resource.TRANSPORT.CONNECTER"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 目的地
        {
          prop: "tbDestination",
          label: t("resource.TRANSPORT.DESTINATION"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 備考
        {
          prop: "tbRemarks",
          label: t("resource.TRANSPORT.REMARKS"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],
      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      transportTableDataLength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
      showFlag: false,

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //権限（false: 日本、true：大連（ 品質保証部））
      isDLUserLocal: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
    };
  },

  mounted() {
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // 権限の取得
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
    this.transportTableDataLength = this.transportTableData.length;
  },

  computed: {
    tableData() {
      return this.transportTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },
  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    // 画面初期化
    init() {
      this.showFlag = true;
      //検索条件リストの初期化(状態リスト)
      initTransSearchList()
        .then((res) => {
          //運送状態
          this.statusList = res.searchStatus;

          //日付初期化
          this.dateInit();

          //検索処理
          this.searchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    //日付初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();
      //日付初期値の設定
      this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
    },

    // 「検索」ボタン
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      // 検索条件の処理
      this.updateSearchForm();

      //検索運送基本情報
      searchTransBasic(this.searchConditionForm)
        .then((res) => {
          // console.log("searchTransBasic: res = " + JSON.stringify(res));
          this.transportTableData = res;
          // データ個数
          this.transportTableDataLength = this.transportTableData.length;

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
          // データ処理
          this.dataProcess();

          //列幅の設定
          setColumnWidth(this.columns, this.transportTableData);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    //データの処理
    dataProcess() {
      this.transportTableData.map((item) => {
        //出発日
        item.tbDepartureDate = formatCurDateToString(item.tbDepartureDate);

        //到着予定日
        item.tbEstArrivalDate = formatCurDateToString(item.tbEstArrivalDate);

        return item;
      });
    },

    updateSearchForm() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      //日付チェック区分の設定
      this.searchConditionForm.isDepartureDate =
        this.transDateLabel === STR_ONE ? true : false;

      //日付の設定
      if (this.dateRange) {
        this.searchConditionForm.searchStartDate = formatCurDateToString(
          this.dateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatCurDateToString(
          this.dateRange[1]
        );
      }
    },

    //複数行データの削除
    deleteClickSelected() {
      let data = this.$refs.transportTableData.selection;
      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];

        // 「運送中、運送済み」のデータの削除が不可
        for (let index = 0; index < data.length; index++) {
          // let dataStatus = data[index].tbTransStatus;
          // if (dataStatus != STATUS_NEW) {
          //   Message.showError(t("message.TRANSPORT.NOT_DELETE"), null);
          //   deleteFlg = false;
          //   break;
          // }

          let transDelFlg = data[index].tbDelFlg;
          // 日本入荷したデータの運送情報は削除できません
          if (transDelFlg != STR_ZERO) {
            Modal.showError("", t("message.TRANSPORT.NOT_DELETE_JP_RECE"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            deleteFlg = false;
            break;
          }
          delList.push(data[index].tbTransNo);
        }

        if (deleteFlg) {
          Modal.showWarning("", t("resource.sys.deleteMessage"), {
            $type: "prompt",
            confirmButtonText: t("resource.button.sure"),
            cancelButtonText: t("resource.button.cancel"),
            showCancelButton: true,
          }).then(() => {
            if (!this.showFlag) {
              this.showFlag = true;
            }

            deleteTransBasicByTransNo(delList)
              .then(() => {
                //削除成功
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
                this.showFlag = false;
              })
              .finally(() => {
                //検索処理を行う
                this.searchClick();
              });
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      if (typeof this.$refs.delBtn !== "undefined") {
        // フォーカス削除
        this.$refs.delBtn.$el.blur();
      }
    },

    // 「新規」ボタン
    addClick() {
      // 運送一覧詳細画面を表示
      ShowTransportEditDialog(
        {
          isAdd: true,
        },
        t("resource.TRANSPORT.TRANSPORT_DETAIL_TITLE"),
        this.searchClick
      );

      if (typeof this.$refs.addBtn !== "undefined") {
        // フォーカス削除
        this.$refs.addBtn.$el.blur();
      }
    },

    //詳細
    detailClick(row) {
      // 運送一覧詳細画面を表示
      ShowTransportEditDialog(
        {
          isAdd: false,
          rowData: row,
        },
        t("resource.TRANSPORT.TRANSPORT_DETAIL_TITLE"),
        this.searchClick
      );
    },

    // 翻页处理
    pageChange(val) {
      this.pageNo = val;
    },
    //毎ページ件数の設定
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    // 每页数据条数
    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    //列幅に自動調整
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.transportTableData);
    },

    //状態の色の設定
    formatStatusColor(row) {
      return row.statusColor;
    },

    //テーブルのソート
    tableSort(column) {
      //ソート後、最初のページに戻る
      this.pageNo = 1;
      masterService.tableSort(this.transportTableData, column);
    },
  },
};
</script>
<style lang="scss" scope>
.order-status {
  flex: 1;
}
</style>
